export const NiveauPermission = ['Lecture', 'Ecriture', 'Aucun', 'NC'] as const
export type NiveauPermission = (typeof NiveauPermission)[number]

export const NiveauPermissionLibelle: Record<NiveauPermission, string> = {
  Ecriture: 'Écriture',
  Lecture: 'Lecture',
  Aucun: 'Aucun',
  NC: 'Non concerné',
} as const
